import theme from '@styles/theme';
export default {
  container: (width: number) => ({
    position: 'absolute',
    bottom: 0,
    left: 0,
    height: '2px',
    width: `${width}%`,
    backgroundColor: theme.rawColors.neutralBlack,
    transition: 'width 1s linear'
  })
};